import { Dashboard, ListAlt, Person, DisplaySettings } from "@mui/icons-material"
import colors from './styles/colors';
const styles = {
  iconSize: {
    p: 0.2,
    fontSize: "22px",
    color: colors.secondary,
  }
}

const Navigation = [
  {
    label: 'Dashboard',
    icon: <Dashboard sx={styles.iconSize} />,
    path: '/',
  },
  {
    label: 'Users',
    icon: <Person sx={styles.iconSize} />,
    path: '/users',
  },
  {
    label: 'Orders',
    icon: <ListAlt sx={styles.iconSize} />,
    path: '/orders',
  },


]

export default Navigation